import React from 'react'
import { NaviGate } from "../../../Utility/function";
import { useNavigate } from "react-router-dom";

const Sales = () => {
    const navigate = useNavigate();
    let menuItems = [
        // {
        //     name: "Quotation",
        //     route: "/Quotation_list",
        //     icon: "bi bi-file-earmark-text",
        //     url: "assets/images/menu/quotetion.png",
        // },
        // {
        //     name: "Sales Window",
        //     route: "/sales_window",
        //     icon: "bi bi-cart-plus",
        //     url: "assets/images/menu/sale-window.png",
        // },
        {
            name: "Sales Order",
            route: "/product_order",
            icon: "bi bi-cart-plus",
            url: "assets/images/menu/sale-window.png",
        },
        {
            name: "Sales List",
            route: "/sales_list",
            icon: "bi bi-list-check",
            url: "assets/images/menu/sale_list.png",
        },
        // {
        //     name: "Find sales Price",
        //     route: "/findsale",
        //     icon: "bi bi-currency-exchange",
        //     url: "assets/images/menu/findsale.png",
        // },
        // {
        //     name: "Return",
        //     route: "/return",
        //     icon: "bi bi-bar-chart",
        //     url: "assets/images/menu/Branch.png",
        // }, 
        // {
        //     name: "Return List",
        //     route: "/return_list_order",
        //     icon: "bi bi-bar-chart",
        //     url: "assets/images/menu/sale_list.png",
        // },
    ]
    const handleCardClick = (route) => {
        navigate(route);
    };
    return (
        <div className="my-4 mx-3 pb-5 ">
            <NaviGate />
            <div className="product-grid row  d-flex justify-content-center align-items-center" style={{ padding: "10 25px", minHeight: "80vh", }}>
                {menuItems
                    // .filter((item) =>
                    //     item.name.toLowerCase().includes(Search.toLowerCase())
                    // )
                    .map((item, index) => (
                        <div className="col-12 col-md-4 col-lg-2 mb-2 mt-2 " key={index}>
                            <div
                                className="card h-100 text-center"
                                onClick={() => handleCardClick(item.route)}
                                style={{ cursor: "pointer" }}
                            >
                                <div className="card-body ">
                                    <img
                                        src={item?.url}
                                        width={"50px"}
                                        style={{ marginTop: "8px" }}
                                        alt={item.name}
                                    />
                                    <h5 className="card-title mt-3 text-small">{item.name}</h5>
                                </div>
                            </div>
                        </div>
                    ))}
            </div>
        </div>
    )
}

export default Sales
